<template>
  <el-card style="max-width: 100%">
    <template #header>
      <slot name="up" />
    </template>
    <slot />
  </el-card>
</template>
